/**
 * Kodahfy Logo Components
 *
 * Font: Urbanist (Google Fonts)
 * Add to your HTML head or import:
 *   <link href="https://fonts.googleapis.com/css2?family=Urbanist:wght@400;500;600&display=swap" rel="stylesheet">
 *
 * Or in CSS:
 *   @import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@400;500;600&display=swap');
 */

import React from 'react';

/**
 * Badge only - the circle K icon
 * @param {number} size - pixel size (default 40)
 * @param {'light' | 'dark'} variant - 'light' for dark backgrounds, 'dark' for light backgrounds
 */
export function KodahfyBadge({ size = 40, variant = 'light' }) {
  const stroke = variant === 'light' ? '#ffffff' : '#0f172a';
  const green = variant === 'light' ? '#22c55e' : '#16a34a';
  const scale = size < 48 ? 1.4 : size < 64 ? 1.2 : 1;

  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none">
      <circle cx="40" cy="40" r="36" stroke={stroke} strokeWidth={2.5 * scale} fill="none"/>
      <path d="M 76 40 A 36 36 0 0 1 40 76" stroke={green} strokeWidth={3 * scale} strokeLinecap="round" fill="none"/>
      <line x1="30" y1="24" x2="30" y2="54" stroke={stroke} strokeWidth={3 * scale} strokeLinecap="round"/>
      <line x1="30" y1="39" x2="50" y2="24" stroke={stroke} strokeWidth={3 * scale} strokeLinecap="round"/>
      <line x1="30" y1="39" x2="50" y2="54" stroke={stroke} strokeWidth={3 * scale} strokeLinecap="round"/>
    </svg>
  );
}

/**
 * Full horizontal lockup - Badge + KODAHFY wordmark with green K
 * @param {number} height - height in pixels (default 40)
 * @param {'light' | 'dark'} variant - 'light' for dark backgrounds, 'dark' for light backgrounds
 */
export function KodahfyLogo({ height = 40, variant = 'light' }) {
  const textColor = variant === 'light' ? '#ffffff' : '#0f172a';
  const green = variant === 'light' ? '#22c55e' : '#16a34a';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: `${height * 0.35}px` }}>
      <KodahfyBadge size={height} variant={variant} />
      <div style={{ display: 'flex' }}>
        <span style={{
          fontFamily: "'Urbanist', sans-serif",
          fontSize: `${height * 0.55}px`,
          fontWeight: 500,
          letterSpacing: `${height * 0.1}px`,
          color: green,
          lineHeight: 1,
        }}>K</span>
        <span style={{
          fontFamily: "'Urbanist', sans-serif",
          fontSize: `${height * 0.55}px`,
          fontWeight: 500,
          letterSpacing: `${height * 0.1}px`,
          color: textColor,
          lineHeight: 1,
        }}>ODAHFY</span>
      </div>
    </div>
  );
}

/**
 * Wordmark only - no badge
 * @param {number} fontSize - font size in pixels (default 22)
 * @param {'light' | 'dark'} variant
 */
export function KodahfyWordmark({ fontSize = 22, variant = 'light' }) {
  const textColor = variant === 'light' ? '#ffffff' : '#0f172a';
  const green = variant === 'light' ? '#22c55e' : '#16a34a';

  return (
    <div style={{ display: 'flex' }}>
      <span style={{
        fontFamily: "'Urbanist', sans-serif",
        fontSize: `${fontSize}px`,
        fontWeight: 500,
        letterSpacing: `${fontSize * 0.2}px`,
        color: green,
        lineHeight: 1,
      }}>K</span>
      <span style={{
        fontFamily: "'Urbanist', sans-serif",
        fontSize: `${fontSize}px`,
        fontWeight: 500,
        letterSpacing: `${fontSize * 0.2}px`,
        color: textColor,
        lineHeight: 1,
      }}>ODAHFY</span>
    </div>
  );
}
